import { buttonClasses, Tab, tabClasses, TabPanel, Tabs, TabsList } from '@mui/base';
import { styled } from '@mui/material';

const StyledTabsList = styled(TabsList)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.sandShade3.main}`,
  display: 'flex',
  gap: '32px',
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.palette.taigaTint1.main,
  border: 'none',
  borderBottom: '1px solid transparent',
  padding: '12px 0',
  cursor: 'pointer',
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.8px',
  textTransform: 'uppercase',
  transition: 'all .5s ease-in-out',

  '&:hover': {
    color: theme.palette.taigaTint1.main,
  },

  '&:focus': {
    color: theme.palette.taiga.main,
  },

  [`&.${tabClasses.selected}`]: {
    borderBottom: `1px solid ${theme.palette.taiga.main}`,
  },

  [`&.${buttonClasses.disabled}`]: {
    opacity: '0.5',
    cursor: 'not-allowed',
  },
}));

const StyledTabPanel = styled(TabPanel)`
  align-items: center;
  height: 100%;
`;

export { Tabs, StyledTab as Tab, StyledTabPanel as TabPanel, StyledTabsList as TabsList };
